import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
// import "../scss/attachmentPreview.scss";

const AttachmentPreview = ({ attachments, onRemove }) => {
    if (attachments.length === 0) return null;

    return (
        <div className="previewContainer">
            {attachments.map((att, index) => (
                <div key={index} className="previewItem">
                    {att.type === 'image' ? (
                        <img src={att.url} alt="" />
                    ) : att.type === 'video' ? (
                        <video src={att.url} />
                    ) : (
                        <div className="filePreview">
                            <DescriptionIcon />
                        </div>
                    )}
                    <div className="removeBtn" onClick={() => onRemove(index)}>
                        <CloseIcon fontSize="small" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AttachmentPreview;